import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Cake } from 'lucide-react';

const Register = ({ setUser }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    cnpj: '',
    contato: '',
    admin_email: '',
    admin_name: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/register-company`, formData);
      localStorage.setItem('token', response.data.access_token);
      setUser(response.data.user);
      toast.success('Empresa cadastrada no plano Free. Você pode ativar o trial quando quiser.');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao cadastrar empresa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100">
      <Card className="w-full max-w-lg shadow-2xl border-pink-100 bg-white/90 backdrop-blur-sm" data-testid="register-card">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-gradient-to-br from-pink-500 to-rose-400 rounded-2xl flex items-center justify-center shadow-lg">
            <Cake className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-3xl font-bold bg-gradient-to-r from-pink-600 to-rose-500 bg-clip-text text-transparent">
            Cadastre sua Confeitaria
          </CardTitle>
          <CardDescription className="text-base">Comece grátis e ative o trial de 90 dias quando quiser</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="nome">Nome da Empresa</Label>
              <Input
                id="nome"
                placeholder="Doce Sabor Confeitaria"
                value={formData.nome}
                onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                required
                className="border-pink-200 focus:border-pink-400"
                data-testid="company-name-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="cnpj">CNPJ (opcional)</Label>
              <Input
                id="cnpj"
                placeholder="00.000.000/0000-00"
                value={formData.cnpj}
                onChange={(e) => setFormData({ ...formData, cnpj: e.target.value })}
                className="border-pink-200 focus:border-pink-400"
                data-testid="cnpj-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="contato">Telefone</Label>
              <Input
                id="contato"
                placeholder="(11) 99999-9999"
                value={formData.contato}
                onChange={(e) => setFormData({ ...formData, contato: e.target.value })}
                required
                className="border-pink-200 focus:border-pink-400"
                data-testid="contact-input"
              />
            </div>
            <div className="border-t border-pink-100 pt-4 mt-4">
              <p className="text-sm font-semibold text-gray-700 mb-3">Dados do Administrador</p>
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="admin_name">Nome Completo</Label>
                  <Input
                    id="admin_name"
                    placeholder="Maria Silva"
                    value={formData.admin_name}
                    onChange={(e) => setFormData({ ...formData, admin_name: e.target.value })}
                    required
                    className="border-pink-200 focus:border-pink-400"
                    data-testid="admin-name-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="admin_email">Email</Label>
                  <Input
                    id="admin_email"
                    type="email"
                    placeholder="admin@empresa.com"
                    value={formData.admin_email}
                    onChange={(e) => setFormData({ ...formData, admin_email: e.target.value })}
                    required
                    className="border-pink-200 focus:border-pink-400"
                    data-testid="admin-email-input"
                  />
                </div>
              </div>
            </div>
            <Button
              type="submit"
              className="w-full bg-gradient-to-r from-pink-500 to-rose-400 hover:from-pink-600 hover:to-rose-500 shadow-md hover:shadow-lg transform hover:scale-[1.02] transition-all"
              disabled={loading}
              data-testid="register-submit-button"
            >
              {loading ? 'Cadastrando...' : 'Cadastrar Empresa'}
            </Button>
          </form>
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Já tem uma conta?{' '}
              <Link to="/login" className="text-pink-600 hover:text-pink-700 font-semibold" data-testid="login-link">
                Faça login
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Register;
